import { render, staticRenderFns } from "./LiteDashboard.vue?vue&type=template&id=a0d98c46&"
import script from "./LiteDashboard.vue?vue&type=script&lang=ts&"
export * from "./LiteDashboard.vue?vue&type=script&lang=ts&"
import style0 from "./LiteDashboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports